import { useEffect, useState } from 'react';
import firstImg from '../../assets/first.png';

interface Props {
  onDone: () => void;
}

export default function Splash({ onDone }: Props) {
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setFading(true), 900);
    const t2 = setTimeout(onDone, 1500);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onDone]);

  return (
    <div id="splash" className={fading ? 'fade' : undefined}>
      <img src={firstImg} alt="청산에 살어리랏다" />
    </div>
  );
}
